/* @flow */

export { ZalgoPromise } from './promise';



// WEBPACK FOOTER //
// ./node_modules/zalgo-promise/src/index.js